<div class="modal-header">
  <h4 class="modal-title pull-left">Error Details</h4>
  <button type="button" class="btn-close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="mb-1">
    <pre>
      <code>
        {{ details }}
      </code>
    </pre>
    <a href (click)="copyMessage(details);">Copy Details</a>
  </div>
</div>